import { useState } from "react";
import { Download, Image as ImageIcon, Copy, Check } from "lucide-react";

const BILDTEXT = `Mise en place für heute Abend.

Sechs Gänge, handgeschrieben auf der Karte, hausgebackenes Sauerteigbrot, geschmorter Kürbis, Tagliolini al Limone, Rinderfilet und zum Schluss Quitte & Zwetschge.

Gekocht wird dort, wo gegessen wird: bei meinen Gästen zu Hause. Ich bringe Küche, Handwerk und Ruhe mit — ihr bleibt am Tisch sitzen.

Termin für Euren Abend? Schreibt mir einfach.
stutz-cuisine.com

#privatkoch #mietkoch #dinnerathome #odenwald #michelstadt #erbach #finedining #menüabend #sauerteig #kochenmitliebe #privatdinner #eventkoch #hessen #bergstraße`;

export default function SocialTab() {
  const [kopiert, setKopiert] = useState(false);

  const kopieren = async () => {
    try {
      await navigator.clipboard.writeText(BILDTEXT);
      setKopiert(true);
      setTimeout(() => setKopiert(false), 2500);
    } catch { /* Browser erlaubt kein Kopieren — Text lässt sich markieren */ }
  };

  return (
    <div className="space-y-8" data-testid="social-tab">
      <div>
        <h2 className="font-serif text-3xl text-[#2C2A26]">Reels &amp; Stories</h2>
        <p className="text-sm text-[#757067] mt-2 max-w-2xl">
          Fertige Videos für Instagram und Facebook — hier ansehen, herunterladen und mit dem
          passenden Bildtext posten.
        </p>
      </div>

      <div className="border border-[#E3DECE] bg-white p-5">
        <p className="text-[10px] uppercase tracking-[0.25em] text-[#BA6D52]">Kulinarischer Dinner-Abend</p>
        <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-7 mt-4 items-start">
          <div>
            <video src="/reel-dinner-abend.mp4" poster="/reel-cover.jpg" controls playsInline
              data-testid="social-reel-player"
              className="w-full border border-[#E3DECE] bg-black" />
            <div className="flex flex-wrap gap-2 mt-4">
              <a href="/reel-dinner-abend.mp4" download="Reel-Dinner-Abend.mp4" data-testid="social-reel-download"
                className="inline-flex items-center gap-2 bg-[#BA6D52] hover:bg-[#A55C43] text-white text-[10px] uppercase tracking-[0.18em] px-4 py-3 transition-colors">
                <Download size={14} /> Video laden
              </a>
              <a href="/reel-cover.jpg" download="Reel-Cover.jpg" data-testid="social-cover-download"
                className="inline-flex items-center gap-2 border border-[#BA6D52] text-[#BA6D52] hover:bg-[#FAF5F1] text-[10px] uppercase tracking-[0.18em] px-4 py-3 transition-colors">
                <ImageIcon size={14} /> Cover laden
              </a>
            </div>
            <p className="text-xs text-[#757067] mt-3">15 Sekunden · 1080 × 1920 · ohne Ton</p>
          </div>

          <div className="space-y-3 text-[#575249] text-sm">
            <p>
              Erst die Menükarte als gesetzte Titelkarte mit dem LS-Monogramm, dann Dein Material eng
              auf Teller, Karte und Gewürzglas — Fenster und Deko sind nicht mehr im Bild. Dazu die
              Einblendungen „Mise en place" und „Gleich wird angerichtet", zum Schluss der Abspann
              mit Kontakt.
            </p>
            <p><b>Ohne Ton</b>, damit Du in Instagram einen Trending-Sound drüberlegen kannst — das
              bringt mehr Reichweite als eigene Musik.</p>
            <ol className="list-decimal pl-5 space-y-1">
              <li>Am Handy „Video laden" antippen — landet in Downloads bzw. Fotos.</li>
              <li>Instagram → Reel → Video wählen → Sound hinzufügen.</li>
              <li>Für die Story dasselbe Video nehmen.</li>
            </ol>
          </div>
        </div>

        <div className="mt-7">
          <p className="text-[10px] uppercase tracking-[0.18em] text-[#757067] mb-2">Bildtext</p>
          <textarea readOnly value={BILDTEXT} rows={10} data-testid="social-caption"
            className="w-full border border-[#E3DECE] bg-[#FAFAF7] p-3 text-sm" />
          <button onClick={kopieren} data-testid="social-caption-copy"
            className="mt-3 inline-flex items-center gap-2 border border-[#BA6D52] text-[#BA6D52] hover:bg-[#FAF5F1] text-[10px] uppercase tracking-[0.18em] px-4 py-2.5 transition-colors">
            {kopiert ? <Check size={14} /> : <Copy size={14} />} {kopiert ? "Kopiert" : "Bildtext kopieren"}
          </button>
        </div>
      </div>
    </div>
  );
}
